import React, { useState } from "react";
import { connect } from "unistore/react";
import Common from "Common";
import Actions from "~/state/Actions";
import styled from "styled-components";
import CreatePoll from "../CreatePoll";
import ListPoll from "../ListPoll";
import { valuesArr } from "../CreatePoll";

const { Button } = Common;

const CreateButton = styled.div`
  width: 100%;
  float: left;
  margin-bottom: 15px;
  margin-top: 5px;
`;

// TODO Refactor to be more generic (kludging task attachment support, but should be generic)

const Voting = (isAdmin) => {
  const [openModel, setOpenModel] = useState(false);
  const [formValues, setFormValues] = useState([]);

  const renderCreatePollHandle = (value) => {
    setOpenModel(value);
  };

  const renderCreatePollButton = () => {
    return (
      <>
        <CreateButton>
          <Button
            size="mini"
            color="primary"
            onClick={() => renderCreatePollHandle(true)}
          >
            Create Poll
          </Button>
        </CreateButton>
      </>
    );
  };

  const renderCreatePoll = () => {
    return (
      <CreatePoll
        openModel={openModel}
        renderCreatePollHandle={renderCreatePollHandle}
        size="small"
        minWidth="42rem"
        setFormValues={setFormValues}
        formValues={formValues}
      />
    );
  };
  return (
    <>
      {isAdmin ? renderCreatePollButton() : null}
      <ListPoll pollList={valuesArr} isAdmin />

      {renderCreatePoll()}
    </>
  );
};

export default connect((store) => ({ store }), Actions)(Voting);
